// Documentation module translations - English
export const documentationEN = {
  // Common
  'Documentation': 'Documentation',
  'Need Help?': 'Need Help?',
  'Email': 'Email',
  'Documentation Center': 'Documentation Center',
  'Check other guides in the Documentation Center': 'Check other guides in the Documentation Center',
  'If you have questions about payment modes or booking management, our support team is here to help:':
    'If you have questions about payment modes or booking management, our support team is here to help:',

  // Categories
  'Studio Bookings': 'Studio Bookings',
  'Event Setup': 'Event Setup',
  'Tickets & Pricing': 'Tickets & Pricing',

  // Payment Mode Documentation
  'Payment Mode Management Guide': 'Payment Mode Management Guide',
  'This comprehensive guide explains how to configure payment modes for your studio bookings and manage the booking approval workflow. Payment modes control how customers pay for their bookings and when money is collected.':
    'This comprehensive guide explains how to configure payment modes for your studio bookings and manage the booking approval workflow. Payment modes control how customers pay for their bookings and when money is collected.',

  // Overview Section
  'Overview: Understanding Payment Modes': 'Overview: Understanding Payment Modes',
  'The system supports four different payment modes, each designed for different business needs:':
    'The system supports four different payment modes, each designed for different business needs:',

  // Payment Modes
  'Manual Mode': 'Manual Mode',
  'Full Payment Mode': 'Full Payment Mode',
  'Deposit Mode': 'Deposit Mode',
  'Hold Mode': 'Hold Mode',

  // Payment Mode Labels
  'No online payment': 'No online payment',
  'Instant charge': 'Instant charge',
  'Partial charge': 'Partial charge',
  'Authorization hold': 'Authorization hold',

  // Payment Mode Descriptions
  'Customer submits booking request without paying online. Owner approves, then collects payment later (cash, invoice, etc.)':
    'Customer submits booking request without paying online. Owner approves, then collects payment later (cash, invoice, etc.)',
  'Customer pays 100% upfront via online payment. Booking is automatically confirmed once payment succeeds.':
    'Customer pays 100% upfront via online payment. Booking is automatically confirmed once payment succeeds.',
  'Customer pays a deposit upfront (e.g., 30%). Remaining balance collected later (before/after session).':
    'Customer pays a deposit upfront (e.g., 30%). Remaining balance collected later (before/after session).',
  'Card is authorized but NOT charged. Owner approves booking → money is captured. Owner rejects → hold is released.':
    'Card is authorized but NOT charged. Owner approves booking → money is captured. Owner rejects → hold is released.',

  // Configuration Section
  'How to Configure Payment Settings': 'How to Configure Payment Settings',
  'Payment settings are configured per studio in the Manage Settings page under the Pricing & Payment tab. Navigate to: Studios → [Your Studio] → Manage Settings → Pricing & Payment':
    'Payment settings are configured per studio in the Manage Settings page under the Pricing & Payment tab. Navigate to: Studios → [Your Studio] → Manage Settings → Pricing & Payment',

  // Configuration Steps
  'Access Payment Settings': 'Access Payment Settings',
  'Select Payment Mode': 'Select Payment Mode',
  'Configure Deposit Settings (if using Deposit Mode)': 'Configure Deposit Settings (if using Deposit Mode)',
  'Configure Booking Rules': 'Configure Booking Rules',
  'Save Your Changes': 'Save Your Changes',

  // Booking Management
  'Managing Booking Requests': 'Managing Booking Requests',
  'Understanding Booking Statuses': 'Understanding Booking Statuses',
  'Understanding Payment Statuses': 'Understanding Payment Statuses',

  // Workflow
  'Workflow: Approving Bookings (Manual & Hold Modes)': 'Workflow: Approving Bookings (Manual & Hold Modes)',
  'View Pending Approvals': 'View Pending Approvals',
  'Review Booking Details': 'Review Booking Details',
  'Approve the Booking': 'Approve the Booking',
  'Reject the Booking (if needed)': 'Reject the Booking (if needed)',

  // Best Practices
  'Best Practices & Tips': 'Best Practices & Tips',
  'Choose the Right Mode for Your Business': 'Choose the Right Mode for Your Business',
  'Respond to Booking Requests Quickly': 'Respond to Booking Requests Quickly',
  'Provide Clear Rejection Reasons': 'Provide Clear Rejection Reasons',
  'Set Appropriate Deposit Amounts': 'Set Appropriate Deposit Amounts',
  'Monitor Your Booking Dashboard': 'Monitor Your Booking Dashboard',
  'Track Your Revenue': 'Track Your Revenue',

  // Quick Reference
  'Quick Reference: Payment Mode Comparison': 'Quick Reference: Payment Mode Comparison',

  // Table Headers and Common Terms
  'Status': 'Status',
  'What It Means': 'What It Means',
  'Payment Status': 'Payment Status',
  'Actions Available': 'Actions Available',
  'Feature': 'Feature',
  'Manual': 'Manual',
  'Full Payment': 'Full Payment',
  'Deposit': 'Deposit',
  'Hold': 'Hold',
  'Best For': 'Best For',
  'Mode': 'Mode',

  // Payment Statuses
  'Unpaid': 'Unpaid',
  'Pending': 'Pending',
  'On Hold': 'On Hold',
  'Deposit Paid': 'Deposit Paid',
  'Paid': 'Paid',
  'Refunded': 'Refunded',

  // Booking Statuses
  'Pending Approval': 'Pending Approval',
  'Confirmed': 'Confirmed',
  'In Progress': 'In Progress',
  'Completed': 'Completed',
  'Rejected': 'Rejected',
  'Cancelled': 'Cancelled',
  'No Show': 'No Show',

  // Actions
  'Approve': 'Approve',
  'Reject': 'Reject',
  'View': 'View',
  'Cancel': 'Cancel',
  'Mark In Progress': 'Mark In Progress',
  'Mark Completed': 'Mark Completed',
  'Collect Balance': 'Collect Balance',

  // Common Descriptions
  'No payment received yet. Common in manual mode bookings before collection.':
    'No payment received yet. Common in manual mode bookings before collection.',
  'Payment initiated but not completed. Customer in checkout process.':
    'Payment initiated but not completed. Customer in checkout process.',
  'Full payment received and confirmed. No balance owed.':
    'Full payment received and confirmed. No balance owed.',
  'Payment was refunded back to customer (full or partial refund).':
    'Payment was refunded back to customer (full or partial refund).',
};
